import { useRef, useState } from "react";
import { DEFAULT_DATA_TABLE_LIMIT, PAGE_Limit } from "../../utils/config";
import styles from "./DataTable.module.scss";

const DataTable = ({
  tableMeata,
  tableData,
  tableSortData = [],
  tableResetRef,
}) => {
  // ソート項目
  const [sortBy, setSortBy] = useState(null);
  // 昇順フラグ
  const [sortAscending, setSortAscending] = useState(true);
  // 1ページの件数
  const [limit, setLimit] = useState(DEFAULT_DATA_TABLE_LIMIT);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);

  // 見出しリンククリック
  const handleTableHeaderClick = (clickedField) => {
    if (clickedField === sortBy)
      setSortAscending((sortAscending) => !sortAscending);
    setSortBy(clickedField);
  };

  // ページクリック
  const handlePageClick = (page) => {
    // モーダル用
    const div = document.getElementById("modalContent");
    if (div != null) {
      // モーダルのスクロール操作
      div.scrollTop = 0;
    } else {
      // 通常画面のスクロール操作
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
    setCurrentPage(page);
  };

  // 表示件数変更
  const handleLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(1);
  };

  const tableDataDict = tableData.reduce((dict, elm) => {
    if (elm.key) {
      dict[elm.key] = elm;
    }
    return dict;
  }, {});

  // ソート
  let sortedData = tableSortData;
  if (sortBy) {
    sortedData = tableSortData.slice().sort((a, b) => {
      //null値が渡った場合は空文字としてソート(String()だと"null"で判定される)
      const a_sort = a[sortBy] ? String(a[sortBy]) : "";
      const b_sort = b[sortBy] ? String(b[sortBy]) : "";
      const sort = a_sort.localeCompare(b_sort);
      return sortAscending ? sort : -sort;
    });
  }

  const maxPageNum = Math.ceil(sortedData.length / Number(limit));
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  sortedData = sortedData.slice(offset, offset + Number(limit));

  // 表示件数form/to
  const from = offset + 1;
  const to = offset + sortedData.length;

  // テーブルのデータ行
  const rawData = sortedData.map((record) => (
    <tr key={record["key"]}>
      {Object.keys(tableDataDict[record.key])
        .filter((key) => key !== "key")
        .map((key) => (
          <td>{tableDataDict[record.key][key]}</td>
        ))}
    </tr>
  ));

  const getChildNode = (page, label) => {
    return (
      <li
        onClick={() => handlePageClick(page)}
        className={`page-item ${currentPage === label ? "active" : ""} ${
          styles.datatable__pagination__item
        }`}
      >
        <div class="page-link"> {label} </div>
      </li>
    );
  };

  //ページネーション・ソートをリセット
  const ResetPagaNation = () => {
    setSortBy(null);
    setCurrentPage(1);
  };

  const Pagination = () => {
    const disp_range = 3;
    if (maxPageNum === 0) {
      //検索結果0件
      return (
        <nav className={styles.datatable__pagination}>
          <ul className={styles.datatable__pagination}></ul>
        </nav>
      );
    }

    const child = [];
    if (currentPage > disp_range + 1) {
      child.push(getChildNode(1, 1));
      child.push(getChildNode(currentPage - 1, "<"));
    }
    for (let i = currentPage - disp_range; i <= currentPage + disp_range; i++) {
      if (i > 0 && i <= maxPageNum) {
        child.push(getChildNode(i, i));
      }
    }
    if (currentPage < maxPageNum - disp_range) {
      child.push(getChildNode(currentPage + 1, ">"));
      child.push(getChildNode(maxPageNum, maxPageNum));
    }
    child.push();

    return (
      <nav className={styles.datatable__pagination}>
        <ul className={styles.datatable__pagination}>{child}</ul>
      </nav>
    );
  };
  /*ページング件数表示 */
  const RecordNum = () => {
    if (tableData.length > 0) {
      return (
        <span
          className={styles.datatable__recordnum}
        >{`${from} - ${to}件 / ${tableData.length}件`}</span>
      );
    } else {
      return <span className={styles.datatable__recordnum}>{`0件`}</span>;
    }
  };

  return (
    <div className={styles.datatable}>
      <RecordNum />
      <select
        name="limit"
        value={limit}
        onChange={(e) => handleLimitChange(e.target.value)}
        className={`form-select ${styles.datatable__dispnum}`}
      >
        {PAGE_Limit.map((el) => (
          <option value={el.value}>{el.label}</option>
        ))}
      </select>
      <Pagination />
      <table className={styles.responsivetable}>
        <thead>
          <tr>
            {tableMeata.map((field) => (
              <th onClick={() => handleTableHeaderClick(field.key)}>
                {field.label}{" "}
                {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{rawData}</tbody>
      </table>
      <input
        type="hidden"
        onClick={ResetPagaNation}
        ref={tableResetRef}
      ></input>
      <Pagination />
    </div>
  );
};

export default DataTable;
